/*
 * GUSTA CUSTOMIZATION: HOMEPAGE TESTIMONIALS
 * Warehouse homepage only. Adds styling hooks to the Judge.me Testimonials
 * Carousel and its outer Shopify app section without changing review content.
 */
(function () {
  'use strict';

  function markTestimonials() {
    document.querySelectorAll('.warehouse--v4.template-index .jdgm-testimonials-container').forEach(function (container) {
      var wrapper = container.closest('.jdgm-carousel-wrapper');

      if (wrapper) {
        wrapper.classList.add('gusta-testimonials-polished');

        var section = wrapper.closest('.shopify-section');
        if (section) section.classList.add('gusta-testimonials-strip');
      }
    });
  }

  function init() {
    markTestimonials();

    var observer = new MutationObserver(markTestimonials);
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      observer.disconnect();
      markTestimonials();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', markTestimonials);
})();
